import React, { useContext } from 'react';
import ReactPaginate from 'react-paginate';
import { useIsFetching } from 'react-query';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import { StoreContext } from '../../context/Store';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Pagination = () => {
  const {
    meta,
    page,
    setPage
  } = useContext(StoreContext);
  const isFetching = useIsFetching();
  const onSelectPage = e => {
    const grid = document.getElementById('int-grid');
    window.scrollTo({
      top: grid.offsetTop - 160,
      behavior: 'smooth'
    });
    setPage(e.selected);
  };
  if (isFetching) {
    return null;
  }
  return ___EmotionJSX(Wrapper, null, meta && ___EmotionJSX("div", null, meta.page_count > 1 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(S.Pagination, null, ___EmotionJSX(ReactPaginate, {
    previousLabel: 'Vorherige',
    nextLabel: 'Nächste',
    breakLabel: '...',
    pageCount: meta.page_count,
    onPageChange: e => onSelectPage(e),
    forcePage: page
  })), ___EmotionJSX(Spacer, null)), ___EmotionJSX(S.Counts, null, ___EmotionJSX("p", null, meta.result_count, " von ", meta.filter_count, " gefundenen Produkten"))));
};
export default Pagination;